module.exports = __webpack_public_path__ + "static/payments-dc833dd74eeffb8d5ffe6ed1af5af085.png";